import * as React from 'react';
import { useLocation } from 'react-router';

const dashboardRoot = (i) => (i === 0 && (location.pathname === '/'))

export const isNavigationActive = () => {
  const { pathname } = useLocation();
  return React.useCallback((routePath: string, i?: number | undefined) => {
    const currentNavigation = pathname.split('/')[1];
    const navigation = routePath.split('/')[1];
    return currentNavigation === navigation || dashboardRoot(i);
  }, [pathname]);
}

export const isSidebarActive = () => {
  const { pathname } = useLocation();
  return React.useCallback((routePath: string, filterPath?: string, isMainPath?: boolean, modulePath?: string) => {
    return pathname === `${routePath}${filterPath || ''}` || (!!isMainPath && !!modulePath && pathname === modulePath)
  }, [pathname]);
}